<template>
  <div>
    <SingleCircle
      class="banner-design-elements"
      width="100px"
      style="right: -25px; top:-25px; opacity: 0.4"
      fill
    />
    <SingleCircle
      class="banner-design-elements"
      width="50px"
      style="right: 50px; top:50px; opacity: 0.4"
      stroke
      :stroke-width="3"
    />
    <HalfCircleTR
      class="banner-design-elements"
      width="150px"
      style="right: 50px; top:0px; opacity: 0.4"
    />
    <Leaf
      class="banner-design-elements"
      width="100px"
      style="right: 180px; top:20px; opacity: 0.4"
      stroke
      :stroke-width="1"
    />
  </div>
</template>

<script>
import Leaf from '@/components/design-elements/leaf.vue'
import HalfCircleTR from '@/components/design-elements/halfCircleTR.vue'
import SingleCircle from '@/components/design-elements/singleCircle.vue'

export default {
  components: {
    Leaf,
    HalfCircleTR,
    SingleCircle
  }
}
</script>
